// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8894421c","455":"0e9b14c7","977":"1dde8ef0"}[chunkId] + ".chunk.js";
};